import type { CSSProperties } from 'react';

import { useAbsenceMarks } from '@/lib/directory/useAbsenceMarks';

/**
 * 이름 옆의 휴직 배지 — 「육아휴직」·「병가휴직」·「휴직」, 시작 전이면 뒤에 「예정」 (사용자 지시 2026-10-26).
 * 조직도 · 인력배치표 · 직원찾기가 같은 것을 쓴다. 휴직이 없으면 아무것도 그리지 않는다.
 */
export function AbsenceBadge({ personnelId, style }: { personnelId: string; style?: CSSProperties }) {
  const mark = useAbsenceMarks().get(personnelId);
  if (!mark) return null;
  return (
    <span title={`${mark.startDate} ~ ${mark.endDate}`} style={{ ...absenceBadge, ...style }}>
      {mark.label}
    </span>
  );
}

const absenceBadge: CSSProperties = {
  fontSize: '10px',
  fontWeight: 600,
  padding: '1px 5px',
  borderRadius: '8px',
  background: '#f1f5f9',
  color: '#475569',
  whiteSpace: 'nowrap',
  flexShrink: 0,
};
